import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { fpColors } from '../../../styles/theme';

/**
 * Dashed-border tile that creates a new group. Sits at the top of the
 * Sharing Groups hub as the primary call-to-action when a user has few
 * or no circles defined.
 */
interface AddGroupCardProps {
  onPress: () => void;
}

export const AddGroupCard: React.FC<AddGroupCardProps> = ({ onPress }) => (
  <Pressable
    onPress={onPress}
    style={({ pressed }) => [styles.card, pressed && styles.pressed]}
    accessibilityRole="button"
    accessibilityLabel="Add new circle"
  >
    <View style={styles.iconTile}>
      <MaterialIcons name="group-add" size={22} color={fpColors.primary} />
    </View>
    <View style={styles.body}>
      <Text style={styles.title}>Add New Circle</Text>
      <Text style={styles.meta}>
        Create a new circle to share specific inventory items.
      </Text>
    </View>
    <MaterialIcons name="add-circle" size={22} color={fpColors.primary} />
  </Pressable>
);

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 14,
    padding: 16,
    borderRadius: 14,
    borderWidth: 1.5,
    borderStyle: 'dashed',
    borderColor: `${fpColors.primary}4d`,
    backgroundColor: `${fpColors.primary}08`,
  },
  pressed: { opacity: 0.85 },
  iconTile: {
    width: 40,
    height: 40,
    borderRadius: 10,
    backgroundColor: `${fpColors.primary}1a`,
    justifyContent: 'center',
    alignItems: 'center',
  },
  body: { flex: 1 },
  title: {
    fontFamily: 'Inter_700Bold',
    fontSize: 15,
    color: fpColors.onSurface,
  },
  meta: {
    fontFamily: 'Inter_400Regular',
    fontSize: 12,
    color: fpColors.onSurfaceVariant,
    marginTop: 2,
  },
});
